"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _useOverlapState2 = _interopRequireDefault(require("../../hooks/useOverlapState.hook"));
var _Overlap = _interopRequireDefault(require("../Overlap"));
var _Header = _interopRequireDefault(require("../Header"));
var _Tabs = _interopRequireDefault(require("../Tabs"));
var _OverlapBody = _interopRequireDefault(require("../OverlapBody"));
var _Text = _interopRequireDefault(require("../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var defaultTabs = [];
var DevKitOverlap = function DevKitOverlap(props) {
  var _tabs$tab;
  var _props$zIndex = props.zIndex,
    zIndex = _props$zIndex === void 0 ? 1000 : _props$zIndex,
    _props$tabs = props.tabs,
    tabs = _props$tabs === void 0 ? defaultTabs : _props$tabs;
  var _useOverlapState = (0, _useOverlapState2["default"])(),
    open = _useOverlapState.state;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    tab = _useState2[0],
    setTab = _useState2[1];
  var rootClass = (0, _useCss["default"])({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    overflow: 'hidden'
  });
  var emptyClass = (0, _useCss["default"])(function (theme) {
    return {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderTop: "2px solid ".concat(theme.palette.accent.primary.color)
    };
  });
  var options = (0, _react.useMemo)(function () {
    return tabs.map(function (t, index) {
      return {
        label: t.label,
        value: index
      };
    });
  }, [tabs]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Overlap["default"], {
    zIndex: zIndex,
    open: open,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: rootClass,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
        type: (_tabs$tab = tabs[tab]) === null || _tabs$tab === void 0 ? void 0 : _tabs$tab.type
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs["default"], {
        options: options,
        value: tab,
        onChange: setTab
      }), tabs.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_OverlapBody["default"], {
        value: tab,
        tabs: tabs,
        open: open
      }), tabs.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: emptyClass,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
          size: "large",
          children: "No tabs provided"
        })
      })]
    })
  });
};
var _default = DevKitOverlap;
exports["default"] = _default;